import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../api/client';
import { logger } from './logger';

export function useRadarHistory(days, symbol, pollMs = 300000) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        try {
            const params = { days, ...(symbol ? { symbol } : {}) };
            const { data: res } = await apiClient.get('/radar/history', { params });
            if (res.window_days === days && (res.symbol || null) === (symbol || null)) setData(res);
            setError(null);
        } catch (e) {
            logger.warn('radar history failed', e);
            setError('Geçmiş yüklenemedi');
        } finally {
            setLoading(false);
        }
    }, [days, symbol]);

    useEffect(() => {
        setLoading(true);
        load();
        const id = setInterval(load, pollMs);
        return () => clearInterval(id);
    }, [load, pollMs]);

    return { data, loading, error, reload: load };
}

export function usePrepAlerts() {
    const [status, setStatus] = useState(null);
    const [saving, setSaving] = useState(false);

    const load = useCallback(async () => {
        try {
            const { data } = await apiClient.get('/radar/prep-alerts');
            setStatus(data);
        } catch (e) {
            logger.warn('prep alerts failed', e);
        }
    }, []);

    const toggle = useCallback(async (enabledOrPayload) => {
        setSaving(true);
        try {
            const payload = typeof enabledOrPayload === 'boolean' ? { enabled: enabledOrPayload } : enabledOrPayload;
            const { data } = await apiClient.put('/radar/prep-alerts', payload);
            setStatus(data);
        } catch (e) {
            logger.warn('prep alerts update failed', e);
        } finally {
            setSaving(false);
        }
    }, []);

    useEffect(() => {
        load();
        const id = setInterval(load, 60000);
        return () => clearInterval(id);
    }, [load]);

    return { status, saving, toggle };
}
